/**
 * Color tokens — ported 1:1 from the design reference (SK Billing.dc.html).
 * The design authored colors in OKLCH; these hex values are the exact sRGB
 * conversions of those OKLCH tokens (so web matches the design pixel-for-pixel
 * and React Native native — which can't parse oklch() — renders identically).
 *
 * AI surfaces use a distinct purple (kept visually separate from accent blue).
 */
export interface ColorScheme {
  paper: string;
  paper2: string;
  paper3: string;
  card: string;
  ink: string;
  ink2: string;
  ink3: string;
  ink4: string;
  line: string;
  lineStrong: string;
  accent: string;
  accentInk: string;
  accentSoft: string;
  accentLine: string;
  info: string;
  infoSoft: string;
  infoLine: string;
  success: string;
  successSoft: string;
  successLine: string;
  warn: string;
  warnSoft: string;
  warnLine: string;
  danger: string;
  dangerSoft: string;
  dangerLine: string;
  neutral: string;
  neutralSoft: string;
  neutralLine: string;
  purple: string;
  purpleSoft: string;
  purpleLine: string;
  white: string;
  black: string;
  transparent: string;
}

export const LightColors: ColorScheme = {
  paper: '#fbfaf8',
  paper2: '#f6f5f2',
  paper3: '#f1f0ec',
  card: '#ffffff',
  ink: '#13161a',
  ink2: '#3e4348',
  ink3: '#6d7277',
  ink4: '#a1a5a9',
  line: '#e2e5e7',
  lineStrong: '#cbced1',
  accent: '#2b64c3',
  accentInk: '#023481',
  accentSoft: '#e6f3ff',
  accentLine: '#bad2f9',
  info: '#0f74c5',
  infoSoft: '#def5ff',
  infoLine: '#aac4df',
  success: '#007834',
  successSoft: '#d8f9dd',
  successLine: '#a8c4b0',
  warn: '#be7125',
  warnSoft: '#ffeec5',
  warnLine: '#dac2b1',
  danger: '#b14e49',
  dangerSoft: '#ffe8e4',
  dangerLine: '#d8b8b6',
  neutral: '#008892',
  neutralSoft: '#d4fbfc',
  neutralLine: '#a0cacd',
  purple: '#8451c9',
  purpleSoft: '#f6ecff',
  purpleLine: '#d8c7f9',
  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',
};

export const DarkColors: ColorScheme = {
  paper: '#101214',
  paper2: '#191b1d',
  paper3: '#222427',
  card: '#1d1f23',
  ink: '#f4f3f0',
  ink2: '#c5c4c0',
  ink3: '#8d8c89',
  ink4: '#646360',
  line: '#303337',
  lineStrong: '#4a4d53',
  accent: '#62a2ff',
  accentInk: '#9ad2ff',
  accentSoft: '#182d50',
  accentLine: '#274b88',
  info: '#6cbdff',
  infoSoft: '#072a4a',
  infoLine: '#445a72',
  success: '#76cf8a',
  successSoft: '#092c13',
  successLine: '#465e50',
  warn: '#fba962',
  warnSoft: '#472400',
  warnLine: '#685547',
  danger: '#f98f87',
  dangerSoft: '#47211e',
  dangerLine: '#694e4e',
  neutral: '#3aced6',
  neutralSoft: '#002b2e',
  neutralLine: '#3d5e63',
  purple: '#b688fe',
  purpleSoft: '#34234f',
  purpleLine: '#573c7f',
  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',
};
